import React from "react";

const Hero = ({ heading, subHeading }) => {
  return (
    <div className="heroWrapper">
      <p className="heroHeading">{heading}</p>
      <p className="heroSubHeading">{subHeading}</p>
    </div>
  );
};

export default Hero;
